import React from 'react';
import { PageLayout } from './PageLayout';
import { Card } from './ui/card';

export function About() {
  return (
    <PageLayout
      title="About"
      description="Learn about Startup Builder and our mission to help entrepreneurs build successful SaaS businesses"
      showHero={true}
    >
      <div className="container mx-auto px-6 py-16 max-w-4xl">
        <div className="space-y-16">
          {/* Hero Section */}
          <section className="text-center space-y-6">
            <h1 className="text-5xl font-bold tracking-tight">
              Building the future of SaaS, one startup at a time
            </h1>
            <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
              Startup Builder empowers entrepreneurs with the tools and insights needed to transform ideas into investment-ready businesses.
            </p>
          </section>

          {/* Mission Section */}
          <section className="space-y-6">
            <h2 className="text-3xl font-semibold">Our Mission</h2>
            <p className="text-lg text-muted-foreground leading-relaxed">
              We believe every great SaaS company starts with a clear vision and solid financial foundation. 
              Our platform provides comprehensive tools for modeling, analyzing, and optimizing your startup's 
              financial structure—from initial investment to unit economics and beyond.
            </p>
          </section>

          {/* Features Section */}
          <section className="space-y-6">
            <h2 className="text-3xl font-semibold">What We Offer</h2>
            <div className="grid md:grid-cols-2 gap-6">
              <Card className="p-6">
                <h3 className="text-xl font-semibold mb-3">Investment Calculator</h3>
                <p className="text-muted-foreground">
                  Model your startup's financial structure with precision. Calculate ROI, break-even points, 
                  and track valuation through funding rounds.
                </p>
              </Card>
              <Card className="p-6">
                <h3 className="text-xl font-semibold mb-3">Unit Economics</h3>
                <p className="text-muted-foreground">
                  Understand your business fundamentals. Analyze customer acquisition costs, lifetime value, 
                  and profitability metrics.
                </p>
              </Card>
              <Card className="p-6">
                <h3 className="text-xl font-semibold mb-3">Cost Analysis</h3>
                <p className="text-muted-foreground">
                  Comprehensive cost breakdown and management. Track operating expenses, team costs, 
                  and infrastructure spending.
                </p>
              </Card>
              <Card className="p-6">
                <h3 className="text-xl font-semibold mb-3">Team Planning</h3>
                <p className="text-muted-foreground">
                  Build and manage your team structure. Plan roles, salaries, and organizational 
                  growth strategically.
                </p>
              </Card>
            </div>
          </section>

          {/* Values Section */}
          <section className="space-y-6">
            <h2 className="text-3xl font-semibold">Our Values</h2>
            <div className="space-y-4">
              <div className="flex items-start space-x-4">
                <div className="w-2 h-2 rounded-full bg-primary mt-2 flex-shrink-0" />
                <div>
                  <h3 className="font-semibold mb-1">Transparency</h3>
                  <p className="text-muted-foreground">
                    Clear, honest financial modeling without hidden complexities.
                  </p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div className="w-2 h-2 rounded-full bg-primary mt-2 flex-shrink-0" />
                <div>
                  <h3 className="font-semibold mb-1">Precision</h3>
                  <p className="text-muted-foreground">
                    Accurate calculations and insights you can trust for critical decisions.
                  </p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div className="w-2 h-2 rounded-full bg-primary mt-2 flex-shrink-0" />
                <div>
                  <h3 className="font-semibold mb-1">Empowerment</h3>
                  <p className="text-muted-foreground">
                    Tools that give entrepreneurs the confidence to build and scale.
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* CTA Section */}
          <section className="text-center space-y-4 pt-8 border-t">
            <h2 className="text-2xl font-semibold">Ready to build your startup?</h2>
            <p className="text-muted-foreground">
              Start modeling your SaaS business today and turn your vision into reality.
            </p>
            <a
              href="/new"
              className="inline-block px-6 py-3 bg-primary text-primary-foreground rounded-md font-medium hover:opacity-90 transition-opacity"
            >
              Get Started
            </a>
          </section>
        </div>
      </div>
    </PageLayout>
  );
}

